<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations, mapState } = createNamespacedHelpers('modal')

export default {
    name: 'Modal',
    props: {
        url: {
            required: false,
            type: String
        },
        modalId: {
            required: true,
            type: String
        }
    },
    computed: {
        ...mapState({
            modalState: state => state.modalState
        }),
        isOpen() {
            return this.modalState && this.modalState.indexOf(this.modalId) === 0;
        }
    },
    watch: {
        modalState(newVal, oldVal) {
            if (this.url && newVal === this.modalId && newVal !== oldVal) {
                // Track Pageview with Matomo
                if (typeof window._paq !== 'undefined') {
                    window._paq.push(['setCustomUrl', this.url]);
                    window._paq.push(['trackPageView']);
                }
            }
        }
    },
    methods: {
        open() {
            this.setModal(this.modalId);
        },
        close() {
            this.setModal(false);
        },
        ...mapMutations([
            'setModal'
        ])
    }
}
</script>
